import React from 'react';
export function HeroSection() {
  return <section className="relative bg-forest text-cream overflow-hidden py-16 md:py-24 lg:py-32" data-id="element-24">
      {/* Subtle radial gradient background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,168,76,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-25"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10" data-id="element-26">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-27">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-28">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-6 text-cream" data-id="element-29">
              El Protocolo de Sustitución Latina (PSL):{' '}
              <span className="text-gold italic font-normal" data-id="element-30">
                Desinflama tu abdomen en 7 días sin renunciar al sabor de
                nuestra cocina.
              </span>
            </h1>

            <h2 className="text-lg sm:text-xl md:text-2xl font-body font-light leading-relaxed mb-10 text-cream/90 max-w-3xl mx-auto lg:mx-0" data-id="element-31">
              Descubre cómo liberar a tu cuerpo de la hinchazón crónica,
              recuperar tu energía y volver a cerrar tus pantalones favoritos
              usando el poder de los ingredientes de nuestra propia tierra.
            </h2>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-32">
              <button onClick={() => {
              document.getElementById('offer')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-forest bg-gold hover:bg-gold/90 transition-all duration-300 rounded-sm shadow-lg hover:shadow-xl hover:-translate-y-1 w-full sm:w-auto text-center cursor-pointer" data-id="element-33">
                ¡QUIERO MI PROTOCOLO AHORA!
              </button>
            </div>
          </div>

          {/* Image Mockup */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none mx-auto relative" data-id="element-34">
            <div className="relative rounded-xl overflow-hidden shadow-2xl shadow-black/40 transform transition-transform hover:scale-[1.02] duration-500" data-id="element-35">
              <div className="absolute inset-0 bg-gold/10 mix-blend-overlay z-10" data-id="element-36"></div>
              <img src="https://cdn.magicpatterns.com/uploads/w27bFKeGjKyasbzsHjGkMh/heylloyd-image-1772331355452.png" alt="El Protocolo de Sustitución Latina (PSL) - Mockup de productos digitales en laptop, tablet y celular mostrando ingredientes frescos" className="w-full h-auto object-cover relative z-0" data-id="element-37" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-gold/20 rounded-full blur-2xl -z-10" data-id="element-38"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-sage/10 rounded-full blur-3xl -z-10" data-id="element-39"></div>
          </div>
        </div>
      </div>
    </section>;
}